// @core/api/endpoints/billing/list_journal_entries.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListJournalEntriesResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List journal entries
 * Returns a paginated list of journal entries with optional filtering by status, type, date range, or account.
 */
export async function ListJournalEntries(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListJournalEntriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/journal-entries`;
  const requestOptions = options;
  return client.get<ListJournalEntriesResponse>(requestPath, { ...requestOptions, params });
}
